'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Carousel, CarouselControls, CarouselItem, CarouselItemNav, CarouselItems, CarouselNextButton, CarouselPreviousButton } from '@/components/elementary/carousel/Carousel';
import { BannerCard } from '@/components/shared/BannerCard';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/styles';
import type { ServerRenderedEntry } from '@/types/helpers';
import { getColsValue } from '@/utils/colsMapping';
export function CardsBannerContent(t0) {
  const $ = _c(30);
  const {
    cards,
    showMoreAfterCount,
    bgClassName,
    disableBannerLayout,
    columns
  } = t0;
  const t = useTranslations("CardsBannerContent");
  const sliceAfter = showMoreAfterCount ?? cards?.length ?? 0;
  const [showMore, setShowMore] = useState(false);
  if (!Array.isArray(cards) || cards.length === 0) {
    return null;
  }
  const cardBackgroundColorVariant = disableBannerLayout ? bgClassName : "bg-neutral-light-100";
  const showCarousel = cards.length > 1;
  let t1;
  if ($[0] !== cardBackgroundColorVariant || $[1] !== cards || $[2] !== showCarousel) {
    t1 = showCarousel && <div className="lg:hidden pb-14"><Carousel className="relative"><CarouselItems className="rounded-xl">{cards.map(card => <CarouselItem key={`carousel-${card.id}`} className="rounded-xl"><BannerCard card={card} cardBackgroundColorVariant={cardBackgroundColorVariant} /></CarouselItem>)}</CarouselItems><CarouselControls className="absolute w-full justify-between -bottom-12 rounded-xl py-2 px-4 gap-7"><CarouselPreviousButton className="shadow-none bg-transparent p-0" /><CarouselItemNav activeColor="neutral-light-600" /><CarouselNextButton className="shadow-none bg-transparent p-0" /></CarouselControls></Carousel></div>;
    $[0] = cardBackgroundColorVariant;
    $[1] = cards;
    $[2] = showCarousel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== cardBackgroundColorVariant || $[5] !== cards || $[6] !== showCarousel) {
    t2 = !showCarousel && <div className="lg:hidden">{cards.map(card_0 => <BannerCard key={`mobile-${card_0.id}`} card={card_0} cardBackgroundColorVariant={cardBackgroundColorVariant} />)}</div>;
    $[4] = cardBackgroundColorVariant;
    $[5] = cards;
    $[6] = showCarousel;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== columns?.column) {
    t3 = cn("hidden lg:grid gap-3 lg:gap-4", getColsValue(columns?.column));
    $[8] = columns?.column;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== cardBackgroundColorVariant || $[11] !== cards || $[12] !== showMore || $[13] !== sliceAfter) {
    let t5;
    if ($[15] !== cardBackgroundColorVariant) {
      t5 = card_1 => <BannerCard key={`grid-${card_1.id}`} card={card_1} cardBackgroundColorVariant={cardBackgroundColorVariant} />;
      $[15] = cardBackgroundColorVariant;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t4 = cards.slice(0, showMore ? cards.length : sliceAfter).map(t5);
    $[10] = cardBackgroundColorVariant;
    $[11] = cards;
    $[12] = showMore;
    $[13] = sliceAfter;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[17] !== t3 || $[18] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== cards.length || $[21] !== showMore || $[22] !== sliceAfter || $[23] !== t) {
    t6 = cards.length > sliceAfter && <div className="hidden lg:flex w-full justify-center items-baseline"><Button variant="primary" size="large" onClick={() => setShowMore(!showMore)}>{showMore ? t("showLess") : t("showMore")}</Button></div>;
    $[20] = cards.length;
    $[21] = showMore;
    $[22] = sliceAfter;
    $[23] = t;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t1 || $[26] !== t2 || $[27] !== t5 || $[28] !== t6) {
    t7 = <>{t1}{t2}{t5}{t6}</>;
    $[25] = t1;
    $[26] = t2;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
}
export default CardsBannerContent;